import { createEpicMiddleware, combineEpics } from 'redux-observable'
import { combineReducers, createStore, applyMiddleware, compose } from 'redux'
import { catchError } from 'rxjs/operators'

import { epic as usersEpic, reducer as usersReducer } from './users'
import { epic as productsEpic, reducer as productsReducer } from './products'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const rootReducer = combineReducers({
  users: usersReducer,
  products: productsReducer,
})

const epics = [
  usersEpic,
  productsEpic,
]

const rootEpic = (action$, store$, dependencies) => {
  return combineEpics(...epics)(action$, store$, dependencies).pipe(
    catchError((error, source) => {
      console.error(error)
      return source
    })
  )
}

const epicMiddleware = createEpicMiddleware()

export const configureStore = () => {
  const store = createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(epicMiddleware)
    )
  )

  window.store = store

  epicMiddleware.run(rootEpic)

  return store
}
